<div class="step-header max-width">
  <h1 class="step-title">The Basics</h1>
  <p class="step-description">Tell us about yourself</p>
</div>

<ng-template #loading>
  <terra-loader></terra-loader>
</ng-template>

<form
  *ngIf="accountDetails$ | async as clientDetails; else loading"
  [formGroup]="pageForm"
  (ngSubmit)="submit()"
  (keydown.enter)="$event.preventDefault()"
  class="terra-error-style"
>
  <div class="form-grid max-width">
    <!-- Company Name -->
    <div class="terra-form-field-wrapper new-row">
      <label for="txtCompanyName" class="text-input-label"
        >Organization name</label
      >
      <mat-form-field appearance="outline">
        <input
          matInput
          id="txtCompanyName"
          formControlName="name"
          autocomplete="company-name"
          class="lo_sensitive"
        />
        <mat-error *ngIf="pageForm.get('name').hasError('required')">
          Required
        </mat-error>
      </mat-form-field>
    </div>

    <!-- DBA - Doing business as (optional) -->
    <div class="terra-form-field-wrapper new-row">
      <label for="txtDba" class="text-input-label"
        >DBA - Doing business as (optional)</label
      >
      <mat-form-field appearance="outline">
        <input
          matInput
          id="txtDba"
          formControlName="doingBusinessAs"
          class="lo_sensitive"
        />
        <mat-error *ngIf="pageForm.get('doingBusinessAs').hasError('required')">
          Required
        </mat-error>
      </mat-form-field>
    </div>

    <!-- registrationNumber-->
    <div class="terra-form-field-wrapper new-row">
      <label for="txtRegistrationNumber" class="text-input-label"
        >Registration Number \ EIN</label
      >
      <mat-form-field appearance="outline">
        <input
          matInput
          id="txtRegistrationNumber"
          formControlName="registrationNumber"
          class="lo_sensitive"
        />
        <mat-error
          *ngIf="pageForm.get('registrationNumber').hasError('required')"
        >
          Required
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Your role in the organization -->
    <div class="terra-form-field-wrapper new-row">
      <label for="ddlRoleInOrganization" class="text-input-label"
        >Your role in the organization
      </label>
      <mat-form-field appearance="outline">
        <mat-select
          formControlName="roleInOrganization"
          id="ddlRoleInOrganization"
          placeholder="Select"
        >
          <mat-option
            *ngFor="let role of OrganizationRole.listAll()"
            [value]="role"
          >
            {{ role | enumString : OrganizationRole }}
          </mat-option>
        </mat-select>
        <mat-error
          *ngIf="pageForm.get('roleInOrganization').hasError('required')"
        >
          Required
        </mat-error>
      </mat-form-field>
    </div>

    <!-- Industry -->
    <div class="terra-form-field-wrapper new-row">
      <label for="ddlIndustry" class="text-input-label">Industry </label>
      <mat-form-field appearance="outline">
        <mat-select
          formControlName="industry"
          id="ddlIndustry"
          placeholder="Select"
        >
          <mat-option
            *ngFor="let industry of OrganizationIndustry.listAll()"
            [value]="industry"
          >
            {{ industry | enumString : OrganizationIndustry }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="pageForm.get('industry').hasError('required')">
          Required
        </mat-error>
      </mat-form-field>
    </div>

    <ng-container *ngIf="clientDetails.organizationDetails">
      <!-- Country -->
      <div class="terra-form-field-wrapper new-row">
        <label for="aucCountryId" class="text-input-label"
          >Country where the business registered</label
        >
        <terra-country-auto-complete
          inputId="aucCountryId"
          controlName="countryId"
          placeholderText="Select country"
          [countriesList]="allCountries"
        >
        </terra-country-auto-complete>
      </div>

      <!-- State -->
      <div
        class="terra-form-field-wrapper new-row"
        *ngIf="pageForm.get('countryId').value === USCountryId"
      >
        <mat-icon
          class="notranslate"
          color="primary"
          matTooltipPosition="right"
          matTooltipClass="terra-tooltip"
          matTooltip="please specify the state where the business is operating, and not the state where the business is registered, in case these two are different"
        >
          help
        </mat-icon>
        <label for="ddlStateName" class="text-input-label"
          >State where the business is located</label
        >
        <mat-form-field appearance="outline">
          <mat-select
            formControlName="stateName"
            id="ddlStateName"
            placeholder="Select"
          >
            <mat-option
              *ngFor="let stateOption of allStates"
              [value]="stateOption.name"
            >
              {{ stateOption.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="pageForm.get('stateName').hasError('required')">
            Required
          </mat-error>
        </mat-form-field>
      </div>
    </ng-container>

    <!-- Error message -->
    <div *ngIf="isSubmitted" class="full-width">
      <p *ngIf="pageForm.invalid" class="error-message">
        Please review and correct the fields marked in red
      </p>
      <p *ngIf="isGeneralServerError" class="error-message">
        {{ generalServerErrorMessage }}
      </p>
    </div>

    <div
      class="form-actions full-width"
      *ngIf="!clientDetails.isClientKYCApproved"
    >
      <button
        type="submit"
        class="page-cta half-width tall-button"
        color="primary"
        mat-flat-button
      >
        <span>Create Account</span>
        <terra-loader *ngIf="formSubmitting"></terra-loader>
      </button>
    </div>
  </div>

  <a
    class="switch-account-type-link max-width"
    (click)="swtichAccountTypeToIndividual()"
    >Switch to Personal Account</a
  >
</form>
